import { render, staticRenderFns } from "./AutorizationReject.vue?vue&type=template&id=878de026&scoped=true&"
import script from "./AutorizationReject.vue?vue&type=script&lang=js&"
export * from "./AutorizationReject.vue?vue&type=script&lang=js&"
import style0 from "./AutorizationReject.vue?vue&type=style&index=0&id=878de026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878de026",
  null
  
)

export default component.exports